<template>
    <craft-work-space :work-space="workSpace"></craft-work-space>
</template>

<script>
    /*
     * 后道工作台
     */
    import CraftWorkSpace from "./CraftWorkSpace"

    export default {
        name: "EndHandleCraftWS",
        data(){
            return {
                workSpace: this.$const.endHandleWorkSpace
            }
        },
        components: {CraftWorkSpace},
    }
</script>

<style scoped>

</style>